import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Result } from '../../shared/models/core/result.model';
import { AuditTrail } from '../../shared/models/audit_trail.model';

@Injectable({
    providedIn: 'root'
})
export class AuditTrailManagementService {
    private baseUrl = `${environment.apiUrl}/audit/audit-trails`;
    private http$ = inject(HttpClient);

    findAuditTrails(page: number = 1, size: number = 10, keywords: string = '', action?: string, excludeAction?: string, username?: string): Observable<Result<AuditTrail>> {
        let params = new HttpParams()
            .set('page', page)
            .set('limit', size);

        if (keywords) {
            params = params.set('search', keywords);
        }

        if (action) {
            params = params.set('action', action);
        }

        if (excludeAction) {
            params = params.set('exclude_action', excludeAction);
        }

        if (username) {
            params = params.set('username', username);
        }

        return this.http$.get<Result<AuditTrail>>(this.baseUrl, { params });
    }
}
